var _style, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 24",
    style: {
      enableBackground: "new 0 0 25 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#5C6E7D;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#5C6E7D;stroke:#5C6E7D;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_linear_x2F_record"
  }, /*#__PURE__*/React.createElement("g", {
    id: "record"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st0",
    d: "M12.5,22c5.6,0,10-4.4,10-10s-4.4-10-10-10s-10,4.4-10,10C2.5,17.6,7.1,22,12.5,22z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.5,13.1c-0.7,0-1.1-0.4-1.1-1.1s0.4-1.1,1.1-1.1s1.1,0.4,1.1,1.1S13.2,13.1,12.5,13.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,13.1c-0.7,0-1.1-0.4-1.1-1.1s0.4-1.1,1.1-1.1c0.6,0,1.1,0.4,1.1,1.1S17.6,13.1,16.9,13.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.1,13.1c-0.7,0-1.1-0.4-1.1-1.1s0.4-1.1,1.1-1.1s1.1,0.4,1.1,1.1S8.7,13.1,8.1,13.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWav);
export default __webpack_public_path__ + "static/media/wav.dbd12ab8f2fb282b18ffa67d9fb947aa.svg";
export { ForwardRef as ReactComponent };